export const boardSprintTour = {
  key: "boardSprint",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-sprint-list"]',
      content: t("Tour_BoardSprint_List"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-sprint-add"]',
      content: t("Tour_BoardSprint_Add"),
      placement: "left",
    },
    {
      target: '[data-tour="board-sprint-complete"]',
      content: t("Tour_BoardSprint_Complete"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-sprint-filter"]',
      content: t("Tour_BoardSprint_Filter"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-sprint-tasks"]',
      content: t("Tour_BoardSprint_Tasks"),
      placement: "top",
    },
    {
      target: '[data-tour="board-sprint-burndown"]',
      content: t("Tour_BoardSprint_Burndown"),
      placement: "top",
    },
  ],
};
